// Formato y tono compartidos de la cintilla y de las gráficas "trading" (Fase 17B).
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const PCT = new Set(["pct", "pct4", "pp"]);

export const fDia = (iso, anio = false) => {
  if (!iso) return "—";
  if (!/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso;
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${+d}-${MES[+m - 1]}${anio ? `-${y}` : ""}`;
};

export const fHora = (iso) => (iso ? new Date(iso).toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "America/Mexico_City" }) : "—");

const compacto = (v) => {
  const a = Math.abs(v);
  if (a >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `$${(v / 1e3).toFixed(1)}K`;
  return `$${v.toFixed(0)}`;
};

export const fValor = (v, fmt, largo = false) => {
  if (v == null) return "—";
  switch (fmt) {
    case "money": return largo ? v.toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 2 }) : compacto(v);
    case "int": return Math.round(v).toLocaleString("es-MX");
    case "pct": return `${(v * 100).toFixed(2)}%`;
    case "pct4": return `${(v * 100).toFixed(4)}%`;
    case "pp": return `${(v * 100).toFixed(2)} pp`;
    case "meses": return `${v.toFixed(1)} m`;
    case "num4": return v.toFixed(4);
    case "num6": return v.toFixed(6);
    default: return String(v);
  }
};

export const flecha = (dir) => (dir === "up" ? "▲" : dir === "down" ? "▼" : "=");

export const fDelta = (it) => {
  if (it.prev == null) return "s/previo";
  if (it.dir === "eq") return PCT.has(it.fmt) ? "0.00 pp" : "0.00%";
  if (PCT.has(it.fmt)) return `${it.delta_abs > 0 ? "+" : ""}${(it.delta_abs * 100).toFixed(2)} pp`;
  if (it.delta_pct == null) return "—";
  return `${it.delta_pct > 0 ? "+" : ""}${(it.delta_pct * 100).toFixed(2)}%`;
};

export const fAbs = (it) => (it.delta_abs == null ? "—" : `${it.delta_abs > 0 ? "+" : ""}${fValor(it.delta_abs, it.fmt === "pct" || it.fmt === "pct4" ? "pp" : it.fmt, true)}`);

export const tonoCls = (it) => (it.dir === "eq" || it.prev == null ? "trd-flat" : it.tono === "good" ? "trd-good" : it.tono === "bad" ? "trd-bad" : "trd-neutral");
